import { incidentDetailReportService } from "fleet/service/incident-detail-report";
import { createApiSaga } from "redux-store/api-sagas";

import { FETCH_INCIDENT_DETAIL_REPORT } from "./actions";

const fetchIncidentDetailReportSaga = createApiSaga({
  fetchAction: FETCH_INCIDENT_DETAIL_REPORT,
  service: incidentDetailReportService.loadByToken,
  serviceName: "incidentDetailReportService.loadByToken",
  reload: false,
});

export { fetchIncidentDetailReportSaga };
